import React from 'react';
// --- external imports ------

import { ListItemContainer, ListItemText, ProfileImg } from './ListItemStyles';
// --- local imports ------

function ListItem(props) {

	function handleOnClick() {
		props.onClick?.(props.entry);
	}

	return (
		<ListItemContainer
			onClick={handleOnClick}
			isSelected={props.isSelected}
			projection={LIST_ITEM_CONTAINER_PROJECTION}
			// add fontSize so ProfileImg position can adjust relative to screen size changes
			fontSize={14}
		>
			<ListItemText
				fontSize={15}
				projection={LIST_ITEM_TEXT_PROJECTION}
				data-testid={props['data-testid']}
			>
				{props.entry.browseText}
			</ListItemText>
			<ProfileImg
				x={485}
				y={228}
				projection={props.entry.browseImage}
			/>
		</ListItemContainer>
	);
}

const LIST_ITEM_CONTAINER_PROJECTION = {
	height: 166
};

const LIST_ITEM_TEXT_PROJECTION = {
	width: 259,
	height: 147
};

export default ListItem;
